import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import CategoriesSection from "./components/CategoriesSection";
import ComparisonSection from "./components/ComparisonSection";
import ArticleGridSection from "./components/ArticleGridSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({"@context":"https://schema.org","@graph":[{"@type":"WebSite","name":"CSSBuy Spreadsheet","url":"https://cssbuyspreadsheets.mom","description":"O melhor CSSBuy Spreadsheet atualizado em 2026. Guias completos, links organizados, vendedores confiáveis e dicas de segurança para streetwear, sneakers e moda.","inLanguage":"pt-BR","potentialAction":{"@type":"SearchAction","target":"https://cssbuyspreadsheets.mom/?s={search_term_string}","query-input":"required name=search_term_string"}},{"@type":"Organization","name":"Equipe CSSBuy Guides","url":"https://cssbuyspreadsheets.mom","description":"Guias independentes sobre CSSBuy Spreadsheet. Não vendemos produtos.","foundingDate":"2025","contactPoint":{"@type":"ContactPoint","contactType":"customer support","url":"https://cssbuyspreadsheets.mom"}}]}) }} />
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <CategoriesSection />
        <ComparisonSection />
        <ArticleGridSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}